module.exports = __webpack_public_path__ + "img/jorge_scherer.bc1a1b52.png";